<mat-form-field appearance="fill" class="dictionary-select">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="formControl" [required]="required">
        <mat-option *ngFor="let dictionaryKey of dictionaryKeys" [value]="dictionaryKey.replace(dictionaryRoot, '')">
          <sc-dictionary-label [dictionaryKey]="dictionaryKey"></sc-dictionary-label>
        </mat-option>
    </mat-select>
</mat-form-field>
